var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"l-modal-overlay c-modal-overlay"},[_c('CelestialQuoteLineBasicInteractable',{staticClass:"c-quote-overlay",attrs:{"quote":_vm.quote}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }